import { render, staticRenderFns } from "./TeC.vue?vue&type=template&id=3e7c2582&scoped=true"
import script from "./TeC.vue?vue&type=script&lang=js"
export * from "./TeC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c2582",
  null
  
)

export default component.exports